export const LOGO_URL = "https://customer-assets-39nsmqrw.emergentagent.net/job_renco-doc-vault/artifacts/c8x1q03j_ChatGPT%20Image%2024%20set%202026%2C%2012_24_18.webp";
export const MASCOT_URL = "https://customer-assets-39nsmqrw.emergentagent.net/job_renco-doc-vault/artifacts/tempoy57_Immagine%20ChatGPT%2026%20set%202026%2C%2011_37_57.png";

export const translations = {
  en: {
    appName: "Horizonte Documenta",
    appTagline: "Document & Compliance Center",
    // auth
    signIn: "Sign in",
    signInSubtitle: "Access the Renco Group compliance vault",
    signInGoogle: "Sign in with Google",
    googleNote: "Access is restricted to @renco.it Google accounts.",
    logout: "Log out",
    authFailed: "Authentication failed",
    // pending
    pendingTitle: "Access pending approval",
    pendingDesc: "Your account has been created. A superadmin must approve your access before you can use Horizonte Documenta.",
    signedInAs: "Signed in as",
    // nav
    dashboard: "Dashboard",
    documents: "Documents",
    companies: "Companies",
    alerts: "Expiry Advisory",
    users: "Users",
    superadmin: "Superadmin",
    admin: "Admin",
    staff: "Staff",
    // dashboard
    overview: "Compliance Overview",
    overviewSub: "Monitor licenses, contracts and correspondence across Renco Group",
    wDocuments: "Documents",
    wContracts: "Contracts",
    wCompliance: "Compliance",
    totalDocuments: "Total Documents",
    totalCompanies: "Companies",
    healthIndex: "Compliance Health",
    expired: "Expired",
    critical: "Critical (<30d)",
    warning: "Warning (30-60d)",
    safe: "Safe (>60d)",
    upcomingRenewals: "Upcoming Renewals",
    expiredDocs: "Expired — Action Required",
    byCompany: "By Company",
    byType: "By Document Type",
    noUpcoming: "No upcoming expiries. All clear.",
    noExpired: "Nothing expired. Well done.",
    daysLeft: "days left",
    daysOverdue: "days overdue",
    attention: "need attention",
    // documents
    documentsSub: "All licenses, contracts and correspondence",
    addDocument: "Add Document",
    editDocument: "Edit Document",
    search: "Search by title, person, notes...",
    allCompanies: "All companies",
    allTypes: "All types",
    allStatus: "All statuses",
    allUrgency: "All urgency",
    title: "Title",
    company: "Company",
    type: "Type",
    issueDate: "Issue date",
    expiryDate: "Expiry date",
    responsible: "Responsible person",
    counterpart: "Counterpart",
    physicalLocation: "Physical copy location",
    physicalLocationPlaceholder: "e.g. Maputo HQ, Cabinet 3, Folder A",
    status: "Status",
    notes: "Notes",
    attachment: "Attachment",
    uploadFile: "Upload file (PDF / image)",
    aiAutofill: "Autofill with AI",
    aiRunning: "Reading document...",
    aiDone: "Fields filled from the document — please review",
    aiHint: "Optional: let AI read the uploaded file and fill the fields",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    saving: "Saving...",
    noDocuments: "No documents found. Add your first document.",
    urgency: "Urgency",
    actions: "Actions",
    confirmDelete: "Delete this document? This cannot be undone.",
    download: "Download",
    bulkDownload: "Download selected",
    bulkPreparing: "Preparing ZIP...",
    bulkReady: "Your ZIP download has started",
    bulkNone: "None of the selected documents have a file to download",
    selected: "selected",
    selectToDownload: "Select documents to download them as a ZIP",
    clear: "Clear",
    currentDocuments: "Current documents",
    archivedDocuments: "Archived documents",
    confirmRenewalArchive: "Confirm renewal / Archive",
    renewArchiveTitle: "Confirm renewal or archive",
    optRenewed: "Document renewed",
    optRenewedDesc: "Replace it with a new or existing document",
    optNotRequired: "Document no longer required",
    optNotRequiredDesc: "Archive without a replacement",
    uploadNew: "Upload the new document",
    orSelectExisting: "— or select an existing document —",
    searchReplacement: "Search a replacement document...",
    noReplacementFound: "No matching document",
    replacement: "Replacement",
    replacementRemoved: "Replacement no longer available",
    renewalNeedsReplacement: "Upload or select a replacement document to confirm renewal",
    archivedStatus: "Archived",
    confirm: "Confirm",
    // types
    statutory: "Statutory Documents",
    license: "License",
    contract: "Contract",
    litigation: "Litigation",
    resolutions: "Resolutions & Powers of Attorney",
    correspondence: "Correspondence",
    other: "Other Documents",
    // status
    active: "Active",
    pending: "Pending",
    renewed: "Renewed",
    // companies
    companiesSub: "Manage Renco Group entities",
    addCompany: "Add Company",
    editCompany: "Edit Company",
    companyName: "Company name",
    legalRep: "Legal representative",
    taxNumber: "Tax number (NUIT)",
    sector: "Sector",
    docs: "docs",
    noCompanies: "No companies yet. Add your first company.",
    confirmDeleteCompany: "Delete this company?",
    // users
    usersSub: "Manage access, approvals and roles",
    name: "Name",
    role: "Role",
    approve: "Approve",
    revoke: "Revoke",
    makeStaff: "Set as Staff",
    makeAdmin: "Set as Admin",
    makeSuperadmin: "Set as Superadmin",
    deleteUser: "Delete user",
    pendingUsers: "Pending approval",
    activeUsers: "Active users",
    noPending: "No pending requests.",
    confirmDeleteUser: "Delete this user permanently?",
    approved: "Approved",
    changeRole: "Change role",
    permissions: "Permissions",
    permTitle: "Access permissions",
    accessLevel: "Can edit & upload",
    viewOnly: "View only — cannot modify",
    canEditUpload: "Can edit & upload documents",
    scopeCompanies: "Companies (none selected = all)",
    scopeTypes: "Document types (none selected = all)",
    allAccess: "All",
    viewLabel: "View",
    editLabel: "Edit",
    docTypes: "types",
    // misc
    required: "This field is required",
    none: "None",
    backLabel: "Back",
    documentDetails: "Document details",
    archivedSub: "Renewed and archived documents — view, download or edit",
    noArchivedDocuments: "No archived documents yet.",
    replacedBy: "Replaced by",
    newDocDetails: "New document details",
    correspondenceSub: "Incoming and outgoing correspondence",
    correspondenceIn: "Correspondence In",
    correspondenceOut: "Correspondence Out",
    addCorrespondence: "Add Correspondence",
    editCorrespondence: "Edit Correspondence",
    direction: "Direction",
    dirIn: "Incoming",
    dirOut: "Outgoing",
    corrDate: "Date (issued / received)",
    linkedCorrespondence: "Linked correspondence",
    linkSearch: "Search correspondence to link...",
    noLinks: "No links yet",
    noCorrespondence: "No correspondence yet.",
    linked: "Linked",
  },
  pt: {
    appName: "Horizonte Documenta",
    appTagline: "Centro de Documentos e Conformidade",
    signIn: "Iniciar sessão",
    signInSubtitle: "Aceda ao cofre de conformidade do Grupo Renco",
    signInGoogle: "Entrar com Google",
    googleNote: "O acesso é restrito a contas Google @renco.it.",
    logout: "Sair",
    authFailed: "Falha na autenticação",
    pendingTitle: "Acesso pendente de aprovação",
    pendingDesc: "A sua conta foi criada. Um superadministrador deve aprovar o seu acesso antes de poder utilizar o Horizonte Documenta.",
    signedInAs: "Sessão iniciada como",
    dashboard: "Painel",
    documents: "Documentos",
    companies: "Empresas",
    alerts: "Avisos de Validade",
    users: "Utilizadores",
    superadmin: "Superadministrador",
    admin: "Administrador",
    staff: "Colaborador",
    overview: "Visão Geral de Conformidade",
    overviewSub: "Monitorize licenças, contratos e correspondência do Grupo Renco",
    wDocuments: "Documentos",
    wContracts: "Contratos",
    wCompliance: "Conformidade",
    totalDocuments: "Total de Documentos",
    totalCompanies: "Empresas",
    healthIndex: "Saúde de Conformidade",
    expired: "Expirado",
    critical: "Crítico (<30d)",
    warning: "Aviso (30-60d)",
    safe: "Seguro (>60d)",
    upcomingRenewals: "Renovações Próximas",
    expiredDocs: "Expirados — Ação Necessária",
    byCompany: "Por Empresa",
    byType: "Por Tipo de Documento",
    noUpcoming: "Sem expirações próximas. Tudo em ordem.",
    noExpired: "Nada expirado. Bom trabalho.",
    daysLeft: "dias restantes",
    daysOverdue: "dias em atraso",
    attention: "requerem atenção",
    documentsSub: "Todas as licenças, contratos e correspondência",
    addDocument: "Adicionar Documento",
    editDocument: "Editar Documento",
    search: "Pesquisar por título, pessoa, notas...",
    allCompanies: "Todas as empresas",
    allTypes: "Todos os tipos",
    allStatus: "Todos os estados",
    allUrgency: "Todas as urgências",
    title: "Título",
    company: "Empresa",
    type: "Tipo",
    issueDate: "Data de emissão",
    expiryDate: "Data de validade",
    responsible: "Pessoa responsável",
    counterpart: "Contraparte",
    physicalLocation: "Localização da cópia física",
    physicalLocationPlaceholder: "ex. Sede Maputo, Armário 3, Pasta A",
    status: "Estado",
    notes: "Notas",
    attachment: "Anexo",
    uploadFile: "Carregar ficheiro (PDF / imagem)",
    aiAutofill: "Preencher com IA",
    aiRunning: "A ler documento...",
    aiDone: "Campos preenchidos a partir do documento — reveja por favor",
    aiHint: "Opcional: deixe a IA ler o ficheiro carregado e preencher os campos",
    edit: "Editar",
    delete: "Eliminar",
    save: "Guardar",
    cancel: "Cancelar",
    saving: "A guardar...",
    noDocuments: "Nenhum documento encontrado. Adicione o primeiro.",
    urgency: "Urgência",
    actions: "Ações",
    confirmDelete: "Eliminar este documento? Não pode ser desfeito.",
    download: "Descarregar",
    bulkDownload: "Descarregar selecionados",
    bulkPreparing: "A preparar ZIP...",
    bulkReady: "O download do ZIP começou",
    bulkNone: "Nenhum dos documentos selecionados tem ficheiro para descarregar",
    selected: "selecionados",
    selectToDownload: "Selecione documentos para os descarregar num ZIP",
    clear: "Limpar",
    currentDocuments: "Documentos em vigor",
    archivedDocuments: "Documentos arquivados",
    confirmRenewalArchive: "Confirmar renovação / Arquivar",
    renewArchiveTitle: "Confirmar renovação ou arquivo",
    optRenewed: "Documento renovado",
    optRenewedDesc: "Substituir por um documento novo ou existente",
    optNotRequired: "Documento já não necessário",
    optNotRequiredDesc: "Arquivar sem substituto",
    uploadNew: "Carregar o novo documento",
    orSelectExisting: "— ou selecione um documento existente —",
    searchReplacement: "Pesquisar documento substituto...",
    noReplacementFound: "Nenhum documento correspondente",
    replacement: "Substituto",
    replacementRemoved: "Substituto já não disponível",
    renewalNeedsReplacement: "Carregue ou selecione um documento substituto para confirmar a renovação",
    archivedStatus: "Arquivado",
    confirm: "Confirmar",
    statutory: "Documentos Estatutários",
    license: "Licença",
    contract: "Contrato",
    litigation: "Contencioso",
    resolutions: "Deliberações e Procurações",
    correspondence: "Correspondência",
    other: "Outros Documentos",
    active: "Ativo",
    pending: "Pendente",
    renewed: "Renovado",
    companiesSub: "Gerir entidades do Grupo Renco",
    addCompany: "Adicionar Empresa",
    editCompany: "Editar Empresa",
    companyName: "Nome da empresa",
    legalRep: "Representante legal",
    taxNumber: "Número fiscal (NUIT)",
    sector: "Setor",
    docs: "docs",
    noCompanies: "Ainda sem empresas. Adicione a primeira.",
    confirmDeleteCompany: "Eliminar esta empresa?",
    usersSub: "Gerir acessos, aprovações e funções",
    name: "Nome",
    role: "Função",
    approve: "Aprovar",
    revoke: "Revogar",
    makeStaff: "Definir como Colaborador",
    makeAdmin: "Definir como Administrador",
    makeSuperadmin: "Definir como Superadministrador",
    deleteUser: "Eliminar utilizador",
    pendingUsers: "Aguardam aprovação",
    activeUsers: "Utilizadores ativos",
    noPending: "Sem pedidos pendentes.",
    confirmDeleteUser: "Eliminar este utilizador permanentemente?",
    approved: "Aprovado",
    changeRole: "Alterar função",
    permissions: "Permissões",
    permTitle: "Permissões de acesso",
    accessLevel: "Pode editar e carregar",
    viewOnly: "Apenas leitura — não pode modificar",
    canEditUpload: "Pode editar e carregar documentos",
    scopeCompanies: "Empresas (nenhuma selecionada = todas)",
    scopeTypes: "Tipos de documento (nenhum selecionado = todos)",
    allAccess: "Todos",
    viewLabel: "Ver",
    editLabel: "Editar",
    docTypes: "tipos",
    required: "Este campo é obrigatório",
    none: "Nenhum",
    backLabel: "Voltar",
    documentDetails: "Detalhes do documento",
    archivedSub: "Documentos renovados e arquivados — ver, descarregar ou editar",
    noArchivedDocuments: "Ainda não há documentos arquivados.",
    replacedBy: "Substituído por",
    newDocDetails: "Dados do novo documento",
    correspondenceSub: "Correspondência recebida e enviada",
    correspondenceIn: "Correspondência Recebida",
    correspondenceOut: "Correspondência Enviada",
    addCorrespondence: "Adicionar Correspondência",
    editCorrespondence: "Editar Correspondência",
    direction: "Sentido",
    dirIn: "Recebida",
    dirOut: "Enviada",
    corrDate: "Data (emissão / receção)",
    linkedCorrespondence: "Correspondência associada",
    linkSearch: "Pesquisar correspondência para associar...",
    noLinks: "Sem associações",
    noCorrespondence: "Ainda não há correspondência.",
    linked: "Associada",
  },
};
